import { render, staticRenderFns } from "./closeSidepanel.vue?vue&type=template&id=3d4475b7"
import script from "./closeSidepanel.vue?vue&type=script&lang=js"
export * from "./closeSidepanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports